
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Search, FileDown, Filter } from "lucide-react";

// Mock data
const movementData = [
  {
    id: 1,
    dateTime: "2025-05-12T09:30:00",
    productName: "Organic Brown Rice 1kg",
    type: "In",
    quantity: 20,
    source: "JiMATBiz",
    user: "Ahmad",
    reference: "PO-2505-001",
    notes: "Weekly restock"
  },
  {
    id: 2,
    dateTime: "2025-05-12T10:15:00",
    productName: "Fresh Milk 1L",
    type: "Out",
    quantity: 2,
    source: "POS Sale",
    user: "Sarah",
    reference: "INV-2505-042",
    notes: ""
  },
  {
    id: 3,
    dateTime: "2025-05-12T11:30:00",
    productName: "Yogurt 500g",
    type: "Out",
    quantity: 1,
    source: "JiMATShop",
    user: "System",
    reference: "ONL-2505-018",
    notes: "Online order"
  },
  {
    id: 4,
    dateTime: "2025-05-11T14:20:00",
    productName: "Whole Wheat Bread",
    type: "Out",
    quantity: 1,
    source: "Return",
    user: "Ahmad",
    reference: "RET-2505-003",
    notes: "Customer return - quality issue"
  },
  {
    id: 5,
    dateTime: "2025-05-11T16:45:00",
    productName: "Instant Coffee 200g",
    type: "In",
    quantity: 10,
    source: "Supplier",
    user: "Ahmad",
    reference: "PO-2505-002",
    notes: ""
  }
];

const StockMovementLogTab = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [movementType, setMovementType] = useState("all");
  
  const filteredMovementData = movementData
    .filter(item =>
      item.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.reference.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.user.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.source.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter(item => movementType === "all" || item.type.toLowerCase() === movementType.toLowerCase());
  
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(date);
  };
  
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold">Stock Movement Log</h2>
        <div className="flex gap-2">
          <select 
            className="rounded border px-2.5 py-1.5"
            value={movementType}
            onChange={(e) => setMovementType(e.target.value)}
          >
            <option value="all">All Movements</option>
            <option value="in">Stock In</option>
            <option value="out">Stock Out</option>
          </select>
          <div className="relative">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search movements..."
              className="pl-8 w-[250px]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Button variant="outline">
            <Filter className="mr-2 h-4 w-4" />
            Advanced Filter
          </Button>
          <Button variant="outline">
            <FileDown className="mr-2 h-4 w-4" />
            Export Log
          </Button>
        </div>
      </div>
      
      <div className="border rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date & Time</TableHead>
              <TableHead>Product Name</TableHead>
              <TableHead>Type</TableHead>
              <TableHead className="text-center">Quantity</TableHead>
              <TableHead>Source/Destination</TableHead>
              <TableHead>User / Staff</TableHead>
              <TableHead>Reference</TableHead>
              <TableHead>Notes</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredMovementData.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{formatDate(item.dateTime)}</TableCell>
                <TableCell className="font-medium">{item.productName}</TableCell>
                <TableCell>
                  <span className={item.type === "In" ? "text-green-600 font-medium" : "text-red-600 font-medium"}>
                    {item.type}
                  </span>
                </TableCell>
                <TableCell className="text-center">{item.quantity}</TableCell>
                <TableCell>{item.source}</TableCell>
                <TableCell>{item.user}</TableCell>
                <TableCell>{item.reference}</TableCell>
                <TableCell className="max-w-[200px] truncate">{item.notes}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default StockMovementLogTab;
